<template>
  <div class="retrieve-area flex-r-center">
    <div class="card-width">
      <el-card class="box-card">
        <div slot="header" class="card-wrap">
          <span class="fz24">找回密码</span>
        </div>
        <el-steps :active="active" align-center>
          <el-step title="设置新密码"></el-step>
          <el-step title="设置成功"></el-step>
        </el-steps>
        <form-data-valid v-if="active==1" @changeActive="changeActive" :verifyId.sync="verifyId"></form-data-valid>
        <!--        <form-data-pass v-if="active==2" @changeActive="changeActive" :verifyId.sync="verifyId"></form-data-pass>-->
        <div v-if="active==2">
          <img class="mb20" src="@/assets/login/icon-finish.png" alt/>
          <div class="fz22 mb20">新密码设置成功</div>
          <div class="fz14">
            <span style="color:#407FFF">{{ passCount }}</span> s后自动跳转到登录
          </div>
        </div>
      </el-card>
    </div>
  </div>
</template>
<script>
import FormDataValid from "./FormDataValid.vue";
import FormDataPass from "./FormDataPass.vue";

export default {
  components: {FormDataValid, FormDataPass},
  data() {
    return {
      active: 1,
      passCount: 5,
      passTimer: null,
      verifyId: '',
    };
  },
  methods: {
    changeActive(param) {
      this.active = param;
      if (param == 2) {
        this.passTimer = setInterval(() => {
          if (this.passCount > 0) {
            this.passCount--;
          } else {
            if (this.passTimer) {
              clearInterval(this.passTimer);
              window.location.href = 'http://seal.lngsyz.com/#/customerEnterprise/login'
              // this.$router.push({
              //   path: "/login"
              // });
            }
          }
        }, 1000);
      }
    }
  }
};
</script>
<style lang="less" scoped>
.retrieve-area {
  height: calc(100vh - 104px);
  padding: 20px 30px;
  background: #f5f7fa;
}

::v-deep .el-steps {
  width: 700px !important;
  margin: 60px auto;
}

::v-deep .el-card {
  width: 1200px;
  height: 730px;
}

::v-deep .el-step .is-process {
  color: #c0c4cc;
  font-weight: normal;
}

::v-deep .el-step .is-process .is-text {
  border-color: #c0c4cc;
}

::v-deep .el-input--prefix .el-input__inner {
  width: 370px;
}
</style>
